import { render } from "./MessagePageView.vue?vue&type=template&id=270f782d"
import script from "./MessagePageView.vue?vue&type=script&lang=js"
export * from "./MessagePageView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__